import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { EmojiIcon } from '../EmojiIcon';
import { getExistingMemoriesLabel, getWritingStatusLabel, getKeptForLabel } from '../../shared/plan-summary-mapper';
import styles from './ProfileSlideV2.css';

function ProfileSlideV2({ results, spriteVersion, isAgeBranch = false }) {
    const rows = [
        {
            label: 'Existing memories',
            icon: 'imagesFill',
            value: getExistingMemoriesLabel(results.userResponses, isAgeBranch)
        },
        {
            label: 'Writing status',
            icon: 'clockFill',
            value: getWritingStatusLabel(results.userResponses)
        },
        {
            label: 'Kept for',
            icon: 'heartFill',
            value: getKeptForLabel(results.userResponses, isAgeBranch)
        }
    ].filter(row => Boolean(row.value));

    return (
        <div className={styles.root}>
            <div className={styles.headingSection}>
                <h1 className={styles.heading}>Your Life Story Plan is ready</h1>
                <p className={styles.description}>All of this has only ever existed in one place. Here’s how it gets out.</p>
            </div>
            <ul className={styles.card}>
                {rows.map(row => (
                    <li className={styles.row} key={row.label}>
                        <span className={styles.iconBadge}>
                            <Icon name={row.icon} className={styles.icon} />
                        </span>
                        <div className={styles.rowContent}>
                            <p className={styles.label}>{row.label}</p>
                            <p className={styles.value}>{row.value}</p>
                        </div>
                    </li>
                ))}
            </ul>
            <p className={styles.note}>
                <EmojiIcon name='shield' version={spriteVersion} className={styles.noteIcon} />
                Private by default. Share only what you choose.
            </p>
        </div>
    );
}

ProfileSlideV2.propTypes = {
    results: PropTypes.shape({
        userResponses: PropTypes.array
    }).isRequired,
    spriteVersion: PropTypes.string.isRequired,
    isAgeBranch: PropTypes.bool
};

export {
    ProfileSlideV2
};
